export const SET_LIST_URL = 'SET_LIST_URL';

export const LIST_REQUEST = 'LIST_REQUEST';
export const LIST_ERROR = 'LIST_ERROR';
export const RECIEVE_LIST = 'RECIEVE_LIST';
export const FETCH_LIST = 'FETCH_LIST';
export const SET_LIST = 'SET_LIST';

export const SET_INDEX_URLS = 'SET_INDEX_URLS';
export const SET_PURPOSES_LIST = 'SET_LIST';
export const SET_FEATURES_LIST = 'SET_FEATURES_LIST';
export const SET_VENDORS_LIST = 'SET_VENDORS_LIST';

export const SET_USER_CONSENT = 'SET_USER_CONSENT';
export const SET_USER_PURPOSES = 'SET_USER_PURPOSES';
export const SET_USER_CUSTOM_PURPOSES = 'SET_USER_CUSTOM_PURPOSES';
export const SET_USER_FEATURES = 'SET_USER_FEATURES';
export const SET_USER_VENDORS = 'SET_USER_VENDORS';

export const REMOVE_USER_PURPOSE = 'REMOVE_USER_PURPOSE';
export const ADD_USER_PURPOSE = 'ADD_USER_PURPOSE';

export const HIDE_GDPR = 'HIDE_GDPR';
export const SHOW_GDPR = 'SHOW_GDPR';

export const CUSTOM_PURPOSES_LIST_REQUEST = 'CUSTOM_PURPOSES_LIST_REQUEST';
export const CUSTOM_PURPOSES_LIST_RECIEVE = 'CUSTOM_PURPOSES_LIST_RECIEVE';
export const CUSTOM_PURPOSES_LIST_ERROR = 'CUSTOM_PURPOSES_LIST_ERROR';
export const SET_CUSTOM_PURPOSES_LIST = 'SET_CUSTOM_PURPOSES_LIST';
export const SET_CUSTOM_PURPOSES_LIST_URL = 'SET_CUSTOM_PURPOSES_LIST_URL';

export const SET_COOKIE_NAME = 'SET_COOKIE_NAME';
export const SET_COOKIE_EXPIRE_TIME = 'SET_COOKIE_EXPIRE_TIME';
export const SET_EXPIRE_TIME_ALL_POSITIVE = 'SET_EXPIRE_TIME_ALL_POSITIVE';
export const SET_EXPIRE_TIME_ONE_NEGATIVE = 'SET_EXPIRE_TIME_ONE_NEGATIVE';

export const SET_SWITCH_PURPOSES = 'SET_SWITCH_PURPOSES';
export const SET_SWITCH_VENDORS = 'SET_SWITCH_VENDORS';
export const SET_SWITCH_CUSTOM = 'SET_SWITCH_CUSTOM';
export const ADD_SWITCH_PURPOSE = 'ADD_SWITCH_PURPOSE';
export const REMOVE_SWITCH_PURPOSE = 'REMOVE_SWITCH_PURPOSE';
export const ADD_SWITCH_VENDOR = 'ADD_SWITCH_VENDOR';
export const REMOVE_SWITCH_VENDOR = 'REMOVE_SWITCH_VENDOR';
export const ADD_SWITCH_CUSTOM = 'ADD_SWITCH_CUSTOM';
export const REMOVE_SWITCH_CUSTOM = 'REMOVE_SWITCH_CUSTOM';

export const SET_IS_INITIAL = 'SET_IS_INITIAL';
export const SET_IS_NOT_INITIAL = 'SET_IS_NOT_INITIAL';

export const TRANSLATED_LIST_REQUEST = 'TRANSLATED_LIST_REQUEST';
export const TRANSLATED_LIST_RECIEVE = 'TRANSLATED_LIST_RECIEVE';
export const TRANSLATED_LIST_ERROR = 'TRANSLATED_LIST_ERROR';
export const SET_TRANSLATED_LIST = 'SET_TRANSLATED_LIST';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE';